import Swal from "sweetalert2";

const SweetAlert = {
  confirmDelete: async (
    title = "Are you sure?",
    text = "You won't be able to revert this!"
  ) => {
    const result = await Swal.fire({
      title,
      text,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    return result.isConfirmed;
  },

  deleteSuccess: (title = "Deleted!", text = "This row has been deleted.") => {
    Swal.fire({
      title,
      text,
      icon: "success",
      confirmButtonColor: "#3085d6",
    });
  },

  confirmClone: async (
    title = "Clone this item?",
    text = "A duplicate copy will be created."
  ) => {
    const result = await Swal.fire({
      title,
      text,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, clone it!",
      cancelButtonText: "Cancel",
    });

    return result.isConfirmed;
  },

  cloneSuccess: (title = "Cloned!", text = "A duplicate has been created successfully.") => {
    Swal.fire({
      title,
      text,
      icon: "success",
      confirmButtonColor: "#3085d6",
      showConfirmButton: true,
    });
  },
};

export default SweetAlert;
